export const CUSTOM_CONTENT_BUTTON_TYPES = {
  ASSIGN_INTERVENTION: 'ASSIGN_INTERVENTION',
  IMPROVE_MASTERY: 'IMPROVE_MASTERY',
}

export const CUSTOM_CONTENT_BUTTON_INFO = {
  [CUSTOM_CONTENT_BUTTON_TYPES.ASSIGN_INTERVENTION]: {
    buttonText: 'ASSIGN INTERVENTION',
    tooltipText:
      'Quickly create targeted content to help students close learning gaps.',
  },
  [CUSTOM_CONTENT_BUTTON_TYPES.IMPROVE_MASTERY]: {
    buttonText: 'IMPROVE MASTERY',
    tooltipText:
      'Create focused materials to help students improve on this specific standard.',
  },
}
